import React from 'react';

const ResourceCard = ({ resource, onView, onDownload }) => {
  return (
    <div
      className="bg-white overflow-hidden flex flex-col rounded-[20px] hover:-translate-y-2.5 transition-all duration-300"
      style={{ boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)' }}
    >
      {/* Card Header */}
      <div
        className="relative flex items-center justify-between p-[30px]"
        style={{ backgroundColor: resource.color }}
      >
        <div
          className="flex items-center justify-center rounded-full w-[60px] h-[60px]"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <span className="w-[30px] h-[30px] text-white flex">
            {resource.icon}
          </span>
        </div>
        <span
          className="text-white font-semibold uppercase text-[0.85rem] tracking-[0.5px]"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
            padding: '8px 16px',
            borderRadius: '20px',
            backdropFilter: 'blur(10px)',
          }}
        >
          {resource.type}
        </span>
      </div>

      {/* Card Body */}
      <div className="flex-1 flex flex-col p-[30px]">
        <h3 className="text-texto-oscuro font-bold mb-[15px] text-[1.5rem] leading-[1.3]">
          {resource.title}
        </h3>
        <p className="text-texto-sec flex-1 mb-[25px] text-[1rem] leading-[1.7]">
          {resource.description}
        </p>

        {/* Actions */}
        <div className="flex flex-wrap gap-[15px]">
          {/* Primary — Ver */}
          <button
            className="flex-1 border-0 font-semibold cursor-pointer flex items-center justify-center uppercase rounded-full text-white bg-gradient-to-br from-icetex to-icetex-dark hover:-translate-y-0.5 transition-all duration-300"
            style={{
              minWidth: '150px',
              padding: '14px 24px',
              fontSize: '0.95rem',
              letterSpacing: '0.3px',
              boxShadow: '0 4px 15px rgba(0, 63, 129, 0.3)',
            }}
            onClick={() => onView(resource.file)}
            aria-label={`Ver ${resource.title}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ width: '18px', height: '18px', marginRight: '8px' }}
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            Ver Documento
          </button>

          {/* Secondary — Descargar */}
          <button
            className="flex-1 font-semibold cursor-pointer flex items-center justify-center uppercase rounded-full text-icetex bg-white border-2 border-icetex hover:bg-icetex hover:text-white hover:-translate-y-0.5 transition-all duration-300"
            style={{
              minWidth: '150px',
              padding: '14px 24px',
              fontSize: '0.95rem',
              letterSpacing: '0.3px',
            }}
            onClick={() => onDownload(resource.file, resource.fileName)}
            aria-label={`Descargar ${resource.title}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ width: '18px', height: '18px', marginRight: '8px' }}
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Descargar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;
